// App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import ThemeProvider from './ThemeProvider';
import AppRoutes from './AppRoutes';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
// Ради побочного эффекта: инициализирует i18next до первой отрисовки
import './i18n';

function App() {
    return (
        <ErrorBoundary>
            <ThemeProvider>
                <Router>
                    <AppRoutes />
                </Router>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
